import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { faEllipsisV, faPlus } from '@fortawesome/free-solid-svg-icons';
import { EmployeeDetails } from '@core/models/employee';
import { GalaxyDialogService, MenuItem } from '@ebcont/ebcont.galaxy.js';
import { UserService } from '@core/services/user/user.service';
import {EMPTY, Observable} from "rxjs";
import {map} from "rxjs/operators";

@Component({
  selector: 'hoc-person-card',
  templateUrl: './hoc-person-card.component.html',
  styleUrls: ['./hoc-person-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class HocPersonCardComponent implements OnInit {
  /** @ignore */
  public name = '';
  /** @ignore */
  public image = '';

  public currentUserEmail: string | null = null;

  /** @ignore */
  public items: { term: string; description: string }[] = [];
  public ellipsisIcon = faEllipsisV;
  public menuItems: MenuItem[];
  public isAdmin = false;

  protected employeeDetails: EmployeeDetails | undefined;

  public isMyProfile$: Observable<boolean> = EMPTY;

  @Input() set details(employeeDetailsParam: EmployeeDetails | undefined) {
    this.employeeDetails = employeeDetailsParam;
    this.refreshData();
  }

  constructor(
    library: FaIconLibrary,
    private userService: UserService,
    dialogService: GalaxyDialogService
  ) {
    library.addIcons(faPlus);
    this.menuItems = [
      {
        label: 'action.download_profile',
        isRouterLink: false,
        id: 'level',
        clickEvent: () => {
          dialogService.add({}, 'profileDownload');
        }
      }
    ];
  }

  public call() {
    window.open(`tel:${this.employeeDetails?.phone}`, '_self');
  }

  public mailto() {
    window.open(`mailto:${this.employeeDetails?.email}`);
  }

  ngOnInit(): void {
    this.updateAdminStatus();
    this.refreshData();

    this.isMyProfile$ = this.userService.getUserEmail().pipe(
        map(loggedEmail => {
          const cardEmail = this.employeeDetails?.email?.toLowerCase().trim();
          const currentUser = loggedEmail?.toLowerCase().trim();
          return !!currentUser && currentUser === cardEmail;
        })
    );


  }

  private updateAdminStatus() {
    this.userService.getAdminStatus().subscribe((value: boolean) => {
      this.isAdmin = value;
    });
  }

  private refreshData(): void {
    if (this.employeeDetails) {
      this.name = this.employeeDetails.name;
      this.image = this.employeeDetails.photo ?? '';
      this.items = [
        { term: 'team.role', description: this.employeeDetails.roleDescription },
        { term: 'team.mobile', description: this.employeeDetails.phone },
        { term: 'team.email', description: this.employeeDetails.email }
      ];
    }
  }

  isMyProfile(): boolean {
    if (!this.currentUserEmail || !this.employeeDetails?.email) {
      return false;
    }
    return this.currentUserEmail.toLowerCase().trim() === this.employeeDetails.email.toLowerCase().trim();
  }

  onDropDownClick($event: MenuItem[]) {
    if ($event.length !== 1) {
      return;
    }
    const event = $event[0];

    if (event.clickEvent) {
      event.clickEvent();
    } else {
      // TODO implement router behaviour
      console.error('Routing not implemented');
    }
  }
}
